// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'app';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M1.4 3.934 8.18.73a2.087 2.087 0 0 1 1.64 0l6.78 3.204c.446.223.819.67.819 1.266v7.376c0 .522-.298 1.043-.82 1.267L9.82 17.27a2.087 2.087 0 0 1-1.638 0L1.4 13.843c-.447-.224-.82-.67-.82-1.267v-7.45c0-.522.298-1.043.82-1.192z' />
    <path d='M17.12 4.38c-.148.224-.297.373-.52.448L9.82 8.255a2.087 2.087 0 0 1-1.64 0L1.4 4.828c-.223-.075-.446-.224-.52-.447m8.046-3.8v1.885m0 2.051v1.885M2.83 11.555.581 12.592M6.788 9.69l-2.06.968m10.442.897 2.249 1.037M11.211 9.69l2.06.968M8.926 8.602v8.835' />
  </g>
);

export const viewBox = '0 0 18 18';
